// extracted by mini-css-extract-plugin
export default {"main":"about_main__dC5T2","bio":"about_bio__MEUX-"};